/* eslint-disable react/no-danger */
import _ from 'lodash'
import React from 'react'
import CurrencyFormat from '../currency-format'
import AddonCustomerRemarkDisplay from '../addon-customer-remark-display'
import combineClassNames from '../../helpers/combineClassNames'
import groupCartLineAddonsWithQuantity from '../../helpers/group-cart-line-addons-with-quantity'

export default function CartLineAddonsView({
  addons,
  currency,
  itemClassName,
  ...others
}) {
  const groupedAddons = groupCartLineAddonsWithQuantity(addons)
  return !_.isEmpty(groupedAddons)
    ? (
      <ul {...others}>
        {
          _.map(groupedAddons, (addon) => {
            const name = _.get(addon, 'colorOption.name', '')
            const Name = () => (
              <>
                {'- '}
                {name}
                <AddonCustomerRemarkDisplay message={_.get(addon, 'customerRemark')} />
              </>
            )
            const price = _.get(addon, 'priceDetails.propertyUnitPrice', '0.0')
            const Price = () => (
              _.toNumber(price) > 0 ? (
                <>
                  {' (+'}
                  <CurrencyFormat
                    value={price}
                    currency={currency}
                  />
                  )
                </>
              ) : null
            )
            const qty = _.get(addon, 'quantity', '1')
            const Qty = () => (
              qty > 1 ? (
                <>
                  {' x'}
                  {qty}
                </>
              ) : null
            )
            return (
              <li
                key={_.get(addon, 'id')}
                className={
                  combineClassNames([
                    // styles.item,
                    itemClassName,
                  ])
                }
              >
                <Name />
                <Price />
                <Qty />
              </li>
            )
          })
        }
      </ul>
    ) : null
}
